var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationOnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24x24/On Light/Checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "view-box",
    opacity: 0.01,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H72V72H0V0Z",
    fill: "#44BA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M20.2577 35.5245C19.1667 34.2776 17.2714 34.1512 16.0245 35.2423C14.7776 36.3333 14.6512 38.2286 15.7423 39.4755L26.2423 51.4755C27.4074 52.8072 29.4661 52.8463 30.681 51.5599L56.181 24.5599C57.3187 23.3553 57.2644 21.4566 56.0599 20.319C54.8553 19.1813 52.9566 19.2356 51.819 20.4401L28.5847 45.0411L20.2577 35.5245Z",
    fill: "#44BA00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOnIcon);
export default __webpack_public_path__ + "static/media/notification-on-icon.e3f7d2fb1ae9993043e9537a1bbb5fff.svg";
export { ForwardRef as ReactComponent };